import React, { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { ContractInformationCard, ContractPlanCardList } from 'components/Card'
import { NavButton } from 'components/Button'
import { ExternalLink } from 'components/Link'

const ContractTemplate: FC = () => {
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <ContractPlanCardList />
      <Spacer size={20} />
      <ContractInformationCard />
      <Spacer size={12} />
      <p className={`${text.color_grey_01} ${text.font_small}`}>
        プランの解約を希望される方は、
        <ExternalLink label={'こちら'} url={'https://sacrisupport.zendesk.com/hc/ja/requests/new'} />
        からお問い合わせください。
      </p>
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default ContractTemplate
